import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'
import LandingPage from '@/views/landingPage/Index.vue'
import Intro from '@/views/Intro.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import LayoutPadrao from '@/layouts/LayoutPadrao.vue'
import Perfil from '@/views/Perfil.vue'
import Projetos from '@/views/Projetos.vue'
import Contato from '@/views/Contato.vue'
import EditarPerfil from '@/views/editarPerfil/LayoutPadrao.vue'
import InformacoesPessoais from '@/views/editarPerfil/InformacoesPessoais.vue'
import OutrasHabilidades from '@/views/editarPerfil/OutrasHabilidades.vue'
import TopHabilidades from '@/views/editarPerfil/TopHabilidades.vue'
import PerfilPublico from '@/views/PerfilPublico.vue'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'Intro', component: LandingPage },
    { path: '/login', name: 'Login', component: Login },
    { path: '/cadastrar', name: 'Register', component: Register },
    { path: '/ns/:username', name: 'PerfilPublico', component: PerfilPublico },
    {
      path: '/espaco-nexa',
      component: LayoutPadrao,
      meta: { requiresAuth: true },
      children: [
        { path: 'perfil', name: 'Perfil', component: Perfil },
        { path: 'projetos', name: 'Projetos', component: Projetos },
        { path: 'contato', name: 'Contato', component: Contato },
        { 
          path: 'editar-perfil',
          component: EditarPerfil,
          name: 'EditarPerfil',
          children: [
            { path: '', redirect: 'informacoes-pessoais' },
            { path: 'informacoes-pessoais', name: 'InformacoesPessoais', component: InformacoesPessoais },
            { path: 'top-habilidades', name: 'TopHabilidades', component: TopHabilidades },
            { path: 'outras-habilidades', name: 'OutrasHabilidades', component: OutrasHabilidades },
          ]
        }
      ]
    },
  ]
});

// Proteção de rota
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
